import Main from './Main.vue'

export default [{
  path: 'pregao-tela2/:id',
  name: 'pregao-tela2',
  component: Main
}
]



// WEBPACK FOOTER //
// ./src/app/website/pregao-tela2/routes.js